import { render, staticRenderFns } from "./FormViewerActions.vue?vue&type=template&id=47e456d4&scoped=true"
import script from "./FormViewerActions.vue?vue&type=script&lang=js"
export * from "./FormViewerActions.vue?vue&type=script&lang=js"
import style0 from "./FormViewerActions.vue?vue&type=style&index=0&id=47e456d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e456d4",
  null
  
)

export default component.exports